/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateTeacherResponse
 */
export interface CreateTeacherResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateTeacherResponse
     */
    id: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the CreateTeacherResponse interface.
 */
export function instanceOfCreateTeacherResponse(value: object): value is CreateTeacherResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateTeacherResponseFromJSON(json: any): CreateTeacherResponse {
    return CreateTeacherResponseFromJSONTyped(json, false);
}

export function CreateTeacherResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTeacherResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
    };
}

export function CreateTeacherResponseToJSON(json: any): CreateTeacherResponse {
    return CreateTeacherResponseToJSONTyped(json, false);
}

export function CreateTeacherResponseToJSONTyped(value?: CreateTeacherResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
    };
}

